"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "role-template-table-edit-col" };
const _hoisted_2 = { class: "svg-container oplus-icon" };
const _hoisted_3 = { class: "role-template-table-edit-col-wrapper role-section-edit-col" };
const common_1 = require("../../common/common");
const DeleteIcon_vue_1 = __importDefault(require("../../vue/icons/DeleteIcon.vue"));
const EditIcon_vue_1 = __importDefault(require("../../vue/icons/EditIcon.vue"));
const vue_3 = require("vue");
const KebabMenuIcon_vue_1 = __importDefault(require("../../vue/icons/KebabMenuIcon.vue"));
const roles_1 = require("../../js/roles");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SectionTemplateTableRow',
    props: {
        template: {
            type: Object,
            required: true,
        },
        showEditButtons: {
            type: Boolean,
            default: false,
        }
    },
    emits: ["emit-template-edit", "emit-template-delete", "emit-show-edit-button"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const timeFrames = (0, vue_3.computed)(() => {
            return props.template.requiredTimeSlots;
        });
        const earliestTime = (0, vue_3.computed)(() => {
            if (timeFrames.value[0]) {
                return (0, common_1.dateToKitchenTime)(timeFrames.value[0].startTime);
            }
            return "";
        });
        const latestTime = (0, vue_3.computed)(() => {
            if (timeFrames.value[timeFrames.value.length - 1]) {
                return (0, common_1.dateToKitchenTime)(timeFrames.value[timeFrames.value.length - 1].endTime);
            }
            return "";
        });
        const largestRequiredCount = (0, vue_3.computed)(() => {
            if (!timeFrames.value[0]) {
                return "";
            }
            return Math.max(...timeFrames.value.map(t => t.requiredCount));
        });
        function handleEditClick() {
            emits("emit-show-edit-button", props.template);
            ;
        }
        function closeEditButtons() {
            emits("emit-show-edit-button", undefined);
        }
        function handleRoleSectionTemplateEdit() {
            emits("emit-template-edit", props.template);
        }
        function handleRoleSectionTemplateDelete() {
            (0, roles_1.openConfirmModal)("削除してもよろしいですか？", () => {
                emits("emit-template-delete", props.template);
            });
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", null, [
                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(__props.template.name), 1 /* TEXT */),
                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(earliestTime.value), 1 /* TEXT */),
                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(latestTime.value), 1 /* TEXT */),
                (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(largestRequiredCount.value), 1 /* TEXT */),
                (0, vue_2.createElementVNode)("td", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createVNode)(KebabMenuIcon_vue_1.default, { onClick: handleEditClick })
                    ]),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", {
                            class: "svg-container oplus-icon role-template-btn",
                            onClick: handleRoleSectionTemplateDelete
                        }, [
                            (0, vue_2.createVNode)(DeleteIcon_vue_1.default)
                        ]),
                        (0, vue_2.createElementVNode)("div", {
                            class: "svg-container oplus-icon role-template-btn",
                            onClick: handleRoleSectionTemplateEdit
                        }, [
                            (0, vue_2.createVNode)(EditIcon_vue_1.default)
                        ]),
                        (0, vue_2.createElementVNode)("div", {
                            class: "role-section-edit-col-overlay",
                            onClick: closeEditButtons
                        })
                    ], 512 /* NEED_PATCH */), [
                        [vue_2.vShow, __props.showEditButtons]
                    ])
                ])
            ]));
        };
    }
});
